import React from 'react';
import PropTypes from 'prop-types';
import { HeroPropType } from '@/components/HeaderHero/util/heroPropType';
import Header from '../Header';

const HeaderContainer = ({ headerData }) => {
  return <Header headerData={headerData} />;
};

export default HeaderContainer;

HeaderContainer.propTypes = {
  headerData: PropTypes.shape({
    header: PropTypes.shape({
      hero: PropTypes.arrayOf(HeroPropType),
    }),
  }),
};
